import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ GET COMPANY ESG SCOPE
 * The set of taxonomy concepts this company has chosen to declare against,
 * out of the full concept catalogue on its connected Ref.ESG_TaxonomyHeader.
 * Targets: CompanyScopeController.get (Corp.usp_Z_09_CompanyEsgScope_Get)
 */
export const fetchCompanyScope = async (corporateEntityId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/company-scope/get",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId })
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Company ESG Scope Fetch Failed:", err);
        return [];
    }
};

/**
 * 🛰️ ADD A CONCEPT TO THE COMPANY'S ESG SCOPE
 * Targets: CompanyScopeController.add (Corp.usp_Z_09_CompanyEsgScope_Add)
 */
export const addScopeConcept = async (corporateEntityId, taxonomyDetailRowId, config) => {
    try {
        const payload = {
            CorporateEntityId: corporateEntityId,
            TaxonomyDetailRowId: taxonomyDetailRowId,
        };

        const rawData = await dbPayload(
            "/api/v1/sustina/company-scope/add",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not add concept to scope.");
        return res.data;
    } catch (err) {
        console.error("Company ESG Scope Add Error:", err);
        throw err;
    }
};

/**
 * 🛰️ REMOVE A CONCEPT FROM THE COMPANY'S ESG SCOPE
 * Targets: CompanyScopeController.remove (Corp.usp_Z_09_CompanyEsgScope_Remove)
 */
export const removeScopeConcept = async (corporateEntityId, taxonomyDetailRowId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/company-scope/remove",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId, TaxonomyDetailRowId: taxonomyDetailRowId })
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not remove concept from scope.");
        return true;
    } catch (err) {
        console.error("Company ESG Scope Remove Error:", err);
        throw err;
    }
};
